import { ImportPfmsDataComponent } from './components/cao/import-pfms-data/import-pfms-data.component';
import { ReturnToFarmerPfmsReportComponent } from './components/cao/return-to-farmer-pfms-report/return-to-farmer-pfms-report.component';
import { SubsidyToVendorPfmsReportComponent } from './components/cao/subsidy-to-vendor-pfms-report/subsidy-to-vendor-pfms-report.component';
import { SubsidyToFarmerPfmsReportComponent } from './components/cao/subsidy-to-farmer-pfms-report/subsidy-to-farmer-pfms-report.component';
import { ViewFarmerApplicationComponent } from './components/je/view-farmer-application/view-farmer-application.component';
import { HelpdeskComponent } from './components/helpdesk/helpdesk.component';
import { MiPhysicalVerificationsComponent } from './components/je/mi-physical-verifications/mi-physical-verifications.component';
import { AttachmentComponent } from './components/je/attachment/attachment.component';
import { FinanceComponent } from './components/je/finance/finance.component';
import { BasicComponent } from './components/je/basic/basic.component';
import { JeApplicationComponent } from './components/je/je-application/je-application.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { MiVendorApplicationVerificationComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification.component';
import { FarmerApplicationVerificationComponent } from './components/department/farmer-application-verification/farmer-application-verification.component';
import { VendorMiEstimationConsentFormComponent } from './components/department/vendor-mi-estimation-consent-form/vendor-mi-estimation-consent-form.component';
import { PondProgressIntimationComponent } from './components/pond-progress-intimation/pond-progress-intimation.component';
import { VendorGuardGuard } from './guards/vendor-guard.guard';
import { VendorConsentFormComponent } from './components/vendor/vendor-consent-form/vendor-consent-form.component';
import { VendorComponent } from './components/vendor/vendor.component';
import { DepartmentConsentFormComponent } from './components/department/department-consent-form/department-consent-form.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { HomePageLayoutComponent } from './components/layouts/home-page-layout/home-page-layout.component';
import { InnerPageLayoutComponent } from './components/layouts/inner-page-layout/inner-page-layout.component';
import { BankDetailsComponent } from './components/registration/bank-details/bank-details.component';
import { PersonalDetailsComponent } from './components/registration/personal-details/personal-details.component';
import { FarmerLandDetailComponent } from './components/registration/farmer-land-detail/farmer-land-detail.component';
import { OnFarmMiComponent } from './components/registration/on-farm-mi/on-farm-mi.component';
import { LoginComponent } from './components/login/login.component';
import { PhoneLoginComponent } from './components/phone-login/phone-login.component';
import { FarmersApplicationComponent } from './components/application/farmers-application/farmers-application.component';
import { ConsentFormComponent } from './components/application/consent-form/consent-form.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DepartmentGuardGuard } from './guards/department-guard.guard';
import { JEGuardGuard } from './guards/je-guard.guard';
import { SdoGuardGuard } from './guards/sdo-guard.guard';
import { PondEstimateComponent } from './components/pond-estimate/pond-estimate.component';


import { VendorBOQComponent } from './components/vendor/vendor-boq/vendor-boq.component';
import { MiChallanComponent } from './components/challan/mi-challan/mi-challan.component';
import { FarmerShareComponent } from './components/challan/mi-challan/farmer-share/farmer-share.component';
import { FullPaymentComponent } from './components/challan/mi-challan/full-payment/full-payment.component';
import { SolarChallanComponent } from './components/challan/solar-challan/solar-challan.component';
import { SanctionLetterComponent } from './components/challan/mi-challan/sanction-letter/sanction-letter.component';
import { AuthGuard } from './guards/auth-guard.service';
import { WorkFlowAllStatusComponent } from './components/department/farmer-application-verification/work-flow-all-status/work-flow-all-status.component';
import { LandingComponent } from './components/landing/landing.component';
import { ActivitiesComponent } from './components/activities/activities.component';
import { OrganizationalSetupComponent } from './components/organizational-setup/organizational-setup.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { FullPaymentchallanDetailsComponent } from './components/vendor/full-paymentchallan-details/full-paymentchallan-details.component';
import { ReportSummaryComponent } from './components/department/report-summary/report-summary.component';
import { VendorApplicationComponent } from './components/vendor/vendor-application/vendor-application.component';
import { PrintFarmersChallanComponent } from './components/department/print-farmers-challan/print-farmers-challan.component';
import { HelpdeskGuard } from './guards/helpdesk.guard';
import { UpdateMiComponentCmlValidityComponent } from './components/department/update-mi-component-cml-validity/update-mi-component-cml-validity.component';
import { ChangeRequestComponent } from './components/farmer/change-request/change-request.component';
import { ViewFormComponent } from './components/sdo/view-form/view-form.component';
import { SdoComponent } from './components/sdo/sdo.component';
import { FarmerAppChangeRequestComponent } from './components/department/farmer-app-change-request/farmer-app-change-request.component';
import { NewInitiativesComponent } from './components/new-initiatives/new-initiatives.component';
import { RtiComponent } from './components/rti/rti.component';
import { MiSurveyComponent } from './components/department/subsidy-lot/mi-survey/mi-survey.component';
import { MiSurveySubsidyDisbursementComponent } from './components/cao/mi-survey-subsidy-disbursement/mi-survey-subsidy-disbursement.component';
import { ApproveFarmersChallanComponent } from './components/department/approve-farmers-challan/approve-farmers-challan.component';
import { CAOGuardGuard } from './guards/cao-guard.guard';
import { FarmerShareToVendorComponent } from './components/department/subsidy-lot/farmer-share-to-vendor/farmer-share-to-vendor.component';
import { SubsidyToVendorComponent } from './components/department/subsidy-lot/subsidy-to-vendor/subsidy-to-vendor.component';
import { SubsidyToFarmerComponent } from './components/department/subsidy-lot/subsidy-to-farmer/subsidy-to-farmer.component';
import { RefundToFarmerComponent } from './components/department/subsidy-lot/refund-to-farmer/refund-to-farmer.component';
import { FarmerShareToVendorPfmsReportComponent } from './components/cao/farmer-share-to-vendor-pfms-report/farmer-share-to-vendor-pfms-report.component';
import { XenGuardGuard } from './guards/xen-guard.guard';
import { XenComponent } from './components/xen/xen.component';
import { XenFormComponent } from './components/xen/xen-form/xen-form.component';
import { TankStage1Component } from './components/tank-stage1/tank-stage1.component';
import { TankStage2Component } from './components/tank-stage2/tank-stage2.component';
import { TankStage3Component } from './components/tank-stage3/tank-stage3.component';
import { EvaluationStudyComponent } from './components/evaluation-study/evaluation-study.component';
import { MicroIrrigationComponent } from './components/micro-irrigation/micro-irrigation.component';
import { ProjectComponent } from './components/project/project.component';
import { AnnualPlanComponent } from './components/annual-plan/annual-plan.component';
import { AchievementsComponent } from './components/achievements/achievements.component';
import { Tankstagesurvey2Component } from './components/department/subsidy-lot/tankstagesurvey2/tankstagesurvey2.component';
import { Tankstagesurvey3Component } from './components/department/subsidy-lot/tankstagesurvey3/tankstagesurvey3.component';
import { Tankstagesurvey1Component } from './components/department/subsidy-lot/tankstagesurvey1/tankstagesurvey1.component';
import { TankStage1PfmsReportComponent } from './components/cao/tank-stage1-pfms-report/tank-stage1-pfms-report.component';
import { TankStage2PfmsReportComponent } from './components/cao/tank-stage2-pfms-report/tank-stage2-pfms-report.component';
import { TankStage3PfmsReportComponent } from './components/cao/tank-stage3-pfms-report/tank-stage3-pfms-report.component';
import { ViewCoOrdinatesComponent } from './components/department/view-co-ordinates/view-co-ordinates.component';
import { DepartmentDashboardComponent } from './components/department/department-dashboard/department-dashboard.component';
import { AppVerificationReportComponent } from './components/department/reports/app-verification-report/app-verification-report.component';
import { MonthWiseReportComponent } from './components/department/reports/app-verification-report/month-wise-report/month-wise-report.component';
import { DistrictWiseReportComponent } from './components/department/reports/app-verification-report/district-wise-report/district-wise-report.component';
import { UserWiseReportComponent } from './components/department/reports/app-verification-report/user-wise-report/user-wise-report.component';
import { VendorWiseReportComponent } from './components/department/reports/app-verification-report/vendor-wise-report/vendor-wise-report.component';
import { EstimationReportComponent } from './components/department/reports/estimation-report/estimation-report.component';
import { EstimationDistrictWiseReportComponent } from './components/department/reports/estimation-report/estimation-district-wise-report/estimation-district-wise-report.component';
import { EstimationMonthWiseReportComponent } from './components/department/reports/estimation-report/estimation-month-wise-report/estimation-month-wise-report.component';
import { EstimationUserWiseReportComponent } from './components/department/reports/estimation-report/estimation-user-wise-report/estimation-user-wise-report.component';
import { EstimationVendorWiseReportComponent } from './components/department/reports/estimation-report/estimation-vendor-wise-report/estimation-vendor-wise-report.component';
import { BOQReportComponent } from './components/department/reports/boq-report/boq-report.component';
import { BoqMonthWiseReportComponent } from './components/department/reports/boq-report/boq-month-wise-report/boq-month-wise-report.component';
import { BoqDistrictWiseReportComponent } from './components/department/reports/boq-report/boq-district-wise-report/boq-district-wise-report.component';
import { BoqVendorWiseReportComponent } from './components/department/reports/boq-report/boq-vendor-wise-report/boq-vendor-wise-report.component';
import { BoqMiTypeReportComponent } from './components/department/reports/boq-report/boq-mi-type-report/boq-mi-type-report.component';
import { EstimationVerificationReportComponent } from './components/department/reports/estimation-verification-report/estimation-verification-report.component';
import { EstVerificationDistrictWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-district-wise-report/est-verification-district-wise-report.component';
import { EstVerificationVendorWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-vendor-wise-report/est-verification-vendor-wise-report.component';
import { EstVerificationUserWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-user-wise-report/est-verification-user-wise-report.component';
import { EstVerificationMonthWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-month-wise-report/est-verification-month-wise-report.component';
import { ChallanReportComponent } from './components/department/reports/challan-report/challan-report.component';
import { ChallanVendorWiseReportComponent } from './components/department/reports/challan-report/challan-vendor-wise-report/challan-vendor-wise-report.component';
import { ChallanDistrictWiseReportComponent } from './components/department/reports/challan-report/challan-district-wise-report/challan-district-wise-report.component';
import { PhysicalVerificationVendorWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-vendor-wise-report/physical-verification-vendor-wise-report.component';
import { PhysicalVerificationMonthWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-month-wise-report/physical-verification-month-wise-report.component';
import { PhysicalVerificationReportComponent } from './components/department/reports/physical-verification-report/physical-verification-report.component';
import { PhysicalVerificationDistrictWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-district-wise-report/physical-verification-district-wise-report.component';
import { PhysicalVerificationUserWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-user-wise-report/physical-verification-user-wise-report.component';
import { FsvReportComponent } from './components/department/reports/fsv-report/fsv-report.component';
import { FsvMonthWiseReportComponent } from './components/department/reports/fsv-report/fsv-month-wise-report/fsv-month-wise-report.component';
import { FsvDistrictWiseReportComponent } from './components/department/reports/fsv-report/fsv-district-wise-report/fsv-district-wise-report.component';
import { FsvVendorWiseReportComponent } from './components/department/reports/fsv-report/fsv-vendor-wise-report/fsv-vendor-wise-report.component';
import { VendorFarmerApplicationComponent } from './components/vendor/vendor-farmer-application/vendor-farmer-application.component';
import { AllSubsidyLotComponent } from './components/department/subsidy-lot/all-subsidy-lot/all-subsidy-lot.component';
import { StvReportComponent } from './components/department/reports/stv-report/stv-report.component';
import { StvMonthWiseComponent } from './components/department/reports/stv-report/stv-month-wise/stv-month-wise.component';
import { StvVendorWiseReportComponent } from './components/department/reports/stv-report/stv-vendor-wise-report/stv-vendor-wise-report.component';
import { StfDistrictWiseReportComponent } from './components/department/reports/stf-report/stf-district-wise-report/stf-district-wise-report.component';
import { StfReportComponent } from './components/department/reports/stf-report/stf-report.component';
import { StfMonthWiseReportComponent } from './components/department/reports/stf-report/stf-month-wise-report/stf-month-wise-report.component';
import { StfVendorWiseReportComponent } from './components/department/reports/stf-report/stf-vendor-wise-report/stf-vendor-wise-report.component';
import { StvDistrictWiseReportComponent } from './components/department/reports/stv-report/stv-district-wise-report/stv-district-wise-report.component';
import { RtfReportComponent } from './components/department/reports/rtf-report/rtf-report.component';
import { RtfDistrictWiseReportComponent } from './components/department/reports/rtf-report/rtf-district-wise-report/rtf-district-wise-report.component';
import { RtfMonthWiseReportComponent } from './components/department/reports/rtf-report/rtf-month-wise-report/rtf-month-wise-report.component';
import { RtfVendorWiseReportComponent } from './components/department/reports/rtf-report/rtf-vendor-wise-report/rtf-vendor-wise-report.component';
import { VendorMiAreaReportComponent } from './components/department/reports/vendor-mi-area-report/vendor-mi-area-report.component';
import { MiVerificationSubsidyReportComponent } from './components/department/reports/mi-verification-subsidy-report/mi-verification-subsidy-report.component';
import { TankAbstractReportComponent } from './components/department/reports/tank-abstract-report/tank-abstract-report.component';
import { Stage1ReportComponent } from './components/department/reports/stage1-report/stage1-report.component';
import { Stage2ReportComponent } from './components/department/reports/stage2-report/stage2-report.component';
import { Stage3ReportComponent } from './components/department/reports/stage3-report/stage3-report.component';
import { Stage1SubsidyReportComponent } from './components/department/reports/stage1-subsidy-report/stage1-subsidy-report.component';
import { Stage3SubsidyReportComponent } from './components/department/reports/stage3-subsidy-report/stage3-subsidy-report.component';
import { Stage2SubsidyReportComponent } from './components/department/reports/stage2-subsidy-report/stage2-subsidy-report.component';
import { CanalAndTubeWellBasedReportComponent } from './components/department/reports/canal-and-tube-well-based-report/canal-and-tube-well-based-report.component';

import { ChallanMonthWiseReportComponent } from './components/department/reports/challan-report/challan-month-wise-report/challan-month-wise-report.component';
import { FarmerApplicationVerificationPendingComponent } from './components/department/farmer-application-verification/farmer-application-verification-pending/farmer-application-verification-pending.component';
import { FarmerApplicationVerificationCompletedComponent } from './components/department/farmer-application-verification/farmer-application-verification-completed/farmer-application-verification-completed.component';
import { FarmerApplicationVerificationCurrentComponent } from './components/department/farmer-application-verification/farmer-application-verification-current/farmer-application-verification-current.component';
import { YearWiseProgressComponent } from './components/department/year-wise-progress/year-wise-progress.component';
import { MiAreaCoveredComponent } from './components/department/mi-area-covered/mi-area-covered.component';
import { RealtimeDataPdmcSchemeComponent } from './components/department/realtime-data-pdmc-scheme/realtime-data-pdmc-scheme.component';
import { MiVendorApplicationVerificationPendingComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-pending/mi-vendor-application-verification-pending.component';
import { MiVendorApplicationVerificationCurrentComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-current/mi-vendor-application-verification-current.component';
import { MiVendorApplicationVerificationApprovedComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-approved/mi-vendor-application-verification-approved.component';
// import { GeolocationComponent } from './components/geolocation/geolocation.component';
import { PreEstimateSurveyComponent } from './components/vendor/pre-estimate-survey/pre-estimate-survey.component';
import { ChallanReconciliationDayReportComponent } from './components/department/reports/challan-reconciliation-day-report/challan-reconciliation-day-report.component';
import { MiSourceLocationComponent } from './components/je/mi-source-location/mi-source-location.component';
import { MiPhysicalLocationComponent } from './components/micada_1.0/mi-physical-location/mi-physical-location.component';
import { SeventyFiveHundredDemoComponent } from './components/department/reports/seventy-five-hundred-demo/seventy-five-hundred-demo.component';
import { AtalUserComponent } from './components/department/reports/atal-user/atal-user.component';
import { MiInventoryDetailsComponent } from './components/vendor/mi-inventory-details/mi-inventory-details.component';
import { MiDaReportComponent } from './components/department/reports/da-report/mi-da-report/mi-da-report.component';
import { PondDaReportComponent } from './components/department/reports/da-report/pond-da-report/pond-da-report.component';
import { DaReportComponent } from './components/department/reports/da-report/da-report.component';
import { VendorPreEstimationReportComponent } from './components/department/reports/vendor-pre-estimation-report/vendor-pre-estimation-report.component';
import { PreEstimateMonthWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-month-wise-report/pre-estimate-month-wise-report.component';
import { PreEstimateDistrictWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-district-wise-report/pre-estimate-district-wise-report.component';
import { PreEstimateUserWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-user-wise-report/pre-estimate-user-wise-report.component';
import { PreEstimateVendorWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-vendor-wise-report/pre-estimate-vendor-wise-report.component';
import { UploadGstComponent } from './components/vendor/upload-gst/upload-gst.component';
import { ImportBankDataComponent } from './components/cao/import-bank-data/import-bank-data.component';
import { OfficeOrdersComponent } from './components/office-orders/office-orders.component';
import { ConsolidatedReportComponent } from './components/department/reports/consolidated-report/consolidated-report.component';
import { PondConsolidateReportComponent } from './components/department/reports/pond-consolidate-report/pond-consolidate-report.component';
import { VendorAppApprovedComponent } from './components/vendor/vendor-application/vendor-app-approved/vendor-app-approved.component';
import { VendorAppPendingComponent } from './components/vendor/vendor-application/vendor-app-pending/vendor-app-pending.component';
import { VendorAppCurrentComponent } from './components/vendor/vendor-application/vendor-app-current/vendor-app-current.component';
import { RequestSolarComponent } from './components/dev/request-solar/request-solar.component';
import { DevGuard } from './guards/dev.guard';
import { SolarProcedureComponent } from './components/dev/solar-procedure/solar-procedure.component';
import { AddToSolarFlowComponent } from './components/dev/add-to-solar-flow/add-to-solar-flow.component';
import { ModifySolarComponent } from './components/dev/modify-solar/modify-solar.component';
import { GetSolarComponent } from './components/dev/get-solar/get-solar.component';
import { SolarListComponent } from './components/dev/solar-list/solar-list.component';
import { SubDevGuard } from './guards/sub-dev.guard';
import { ApplicationTypeReportComponent } from './components/department/application-type-report/application-type-report.component';
import { MiPhysicalVerificationCurrentComponent } from './components/je/mi-physical-verifications/mi-physical-verification-current/mi-physical-verification-current.component';
import { MiPhysicalVerficationCompletedComponent } from './components/je/mi-physical-verifications/mi-physical-verfication-completed/mi-physical-verfication-completed.component';
import { MiPhysicalVerificationPendingComponent } from './components/je/mi-physical-verifications/mi-physical-verification-pending/mi-physical-verification-pending.component';
import { SanctionLetterComponentComponent } from './components/challan/sanction-letter-component/sanction-letter-component.component';
import { ImageAttachmentsComponent } from './components/je/image-attachments/image-attachments.component';
import { TargetSystemComponent } from './components/admin-panel/target-system/target-system.component';
import { InventoryReportComponent } from './components/department/reports/inventory-report/inventory-report.component';
import { ErrorTrackingComponent } from './components/dev/error-tracking/error-tracking.component';
import { TankStage1PendingComponent } from './components/tank-stage1/tank-stage1-pending/tank-stage1-pending.component';
import { TankStage1CurrentComponent } from './components/tank-stage1/tank-stage1-current/tank-stage1-current.component';
import { TankStage1ApprovedComponent } from './components/tank-stage1/tank-stage1-approved/tank-stage1-approved.component';
import { TankStage2PendingComponent } from './components/tank-stage2/tank-stage2-pending/tank-stage2-pending.component';
import { TankStage2CurrentComponent } from './components/tank-stage2/tank-stage2-current/tank-stage2-current.component';
import { TankStage2ApprovedComponent } from './components/tank-stage2/tank-stage2-approved/tank-stage2-approved.component';
import { TankStage3PendingComponent } from './components/tank-stage3/tank-stage3-pending/tank-stage3-pending.component';
import { TankStage3CurrentComponent } from './components/tank-stage3/tank-stage3-current/tank-stage3-current.component';
import { TankStage3ApprovedComponent } from './components/tank-stage3/tank-stage3-approved/tank-stage3-approved.component';
import { PreEstimateSurveyPendingComponent } from './components/vendor/pre-estimate-survey/pre-estimate-survey-pending/pre-estimate-survey-pending.component';
import { PreEstimateSurveyApprovedComponent } from './components/vendor/pre-estimate-survey/pre-estimate-survey-approved/pre-estimate-survey-approved.component';
import { PreEstimateSurveyCurrentComponent } from './components/vendor/pre-estimate-survey/pre-estimate-survey-current/pre-estimate-survey-current.component';
import { VendorBoqPendingComponent } from './components/vendor/vendor-boq/vendor-boq-pending/vendor-boq-pending.component';
import { VendorBoqApprovedComponent } from './components/vendor/vendor-boq/vendor-boq-approved/vendor-boq-approved.component';
import { VendorBoqCurrentComponent } from './components/vendor/vendor-boq/vendor-boq-current/vendor-boq-current.component';
import { CanalTargetComponent } from './components/target/canal-target/canal-target.component';
import { CropMasterStatusComponent } from './components/target/crop-master-status/crop-master-status.component';
import { UserActionGuard } from './guards/user-action.guard';
import { StpTargetComponent } from './components/target/stp-target/stp-target.component';
import { OverFlowPondComponent } from './components/target/over-flow-pond/over-flow-pond.component';
import { SubsidyWiseReportComponent } from './components/department/reports/subsidy-wise-report/subsidy-wise-report.component';
import { FarmerShareToFarmerPfmsReportComponent } from './components/cao/farmer-share-to-farmer-pfms-report/farmer-share-to-farmer-pfms-report.component';
import { SubsidyToFarmerAbyPfmsReportComponent } from './components/cao/subsidy-to-farmer-aby-pfms-report/subsidy-to-farmer-aby-pfms-report.component';
import { SubsidyToVendorAbyPfmsReportComponent } from './components/cao/subsidy-to-vendor-aby-pfms-report/subsidy-to-vendor-aby-pfms-report.component';
import { TankStage1AbyPfmsReportComponent } from './components/cao/tank-stage1-aby-pfms-report/tank-stage1-aby-pfms-report.component';
import { TankStage2AbyPfmsReportComponent } from './components/cao/tank-stage2-aby-pfms-report/tank-stage2-aby-pfms-report.component';
import { TankStage3AbyPfmsReportComponent } from './components/cao/tank-stage3-aby-pfms-report/tank-stage3-aby-pfms-report.component';
import { RefundToFarmerAbyComponent } from './components/cao/refund-to-farmer-aby/refund-to-farmer-aby.component';
import { ChangeVendorComponent } from './components/department/farmer-queries/change-vendor/change-vendor.component';
import { ChangeProgramComponent } from './components/department/farmer-queries/change-program/change-program.component';
import { UnhideApplicationComponent } from './components/department/farmer-queries/unhide-application/unhide-application.component';
import { TubewellConnectionLoginComponent } from './components/tubewell-connection-login/tubewell-connection-login.component';
import { LotWiseReportComponent } from './components/department/reports/lot-wise-report/lot-wise-report.component';
import { FsvLotReportComponent } from './components/department/reports/lot-wise-report/fsv-lot-report/fsv-lot-report.component';
import { StfLotReportComponent } from './components/department/reports/lot-wise-report/stf-lot-report/stf-lot-report.component';
import { StvLotReportComponent } from './components/department/reports/lot-wise-report/stv-lot-report/stv-lot-report.component';
import { RtfLotReportComponent } from './components/department/reports/lot-wise-report/rtf-lot-report/rtf-lot-report.component';
import { Stage1LotReportComponent } from './components/department/reports/lot-wise-report/stage1-lot-report/stage1-lot-report.component';
import { Stage3LotReportComponent } from './components/department/reports/lot-wise-report/stage3-lot-report/stage3-lot-report.component';
import { Stage2LotReportComponent } from './components/department/reports/lot-wise-report/stage2-lot-report/stage2-lot-report.component';
import { NewTargetComponent } from './components/home-page/new-target/new-target.component';
import { SubsidyToFarmerAtalComponent } from './components/department/subsidy-lot/subsidy-to-farmer-atal/subsidy-to-farmer-atal.component';
import { ChallanReportByVendorIdComponent } from './components/department/reports/challan-report-by-vendor-id/challan-report-by-vendor-id.component';
import { LotReportComponent } from './components/department/reports/lot-report/lot-report.component';
import { MiConsolidatedCountWiseReportComponent } from './components/department/reports/consolidated-report/mi-consolidated-count-wise-report/mi-consolidated-count-wise-report.component';
import { FailedMiPaymentFsvComponent } from './components/department/failed-mi-payment/failed-mi-payment-fsv/failed-mi-payment-fsv.component';
import { FailedMiPaymentStfComponent } from './components/department/failed-mi-payment/failed-mi-payment-stf/failed-mi-payment-stf.component';
import { FailedMiPaymentStvComponent } from './components/department/failed-mi-payment/failed-mi-payment-stv/failed-mi-payment-stv.component';
import { FailedMiPaymentComponent } from './components/department/failed-mi-payment/failed-mi-payment.component';
import { FailedPondPaymentComponent } from './components/department/failed-pond-payment/failed-pond-payment.component';
import { FailedPondPaymentS1Component } from './components/department/failed-pond-payment/failed-pond-payment-s1/failed-pond-payment-s1.component';
import { FailedPondPaymentS2Component } from './components/department/failed-pond-payment/failed-pond-payment-s2/failed-pond-payment-s2.component';
import { FailedPondPaymentS3Component } from './components/department/failed-pond-payment/failed-pond-payment-s3/failed-pond-payment-s3.component';
import { PondCountWiseReportComponent } from './components/department/reports/consolidated-report/pond-count-wise-report/pond-count-wise-report.component';
import { NewWorkComponent } from './components/contractor/new-work/new-work.component';
import { UpdateWorkComponent } from './components/contractor/update-work/update-work.component';
import { ContractorGuard } from './guards/contractor.guard';
import { ContractorDashboardComponent } from './components/contractor/contractor-dashboard/contractor-dashboard.component';
import { FailedMiPaymentRtfComponent } from './components/department/failed-mi-payment/failed-mi-payment-rtf/failed-mi-payment-rtf.component';
import { MiConsolidatedTotalAppReportComponent } from './components/department/reports/consolidated-report/mi-consolidated-total-app-report/mi-consolidated-total-app-report.component';
import { PhysicalFinTargetComponent } from './components/department/physical-fin-target/physical-fin-target.component';
import { BeneficiaryDetailsComponent } from './components/beneficiary-details/beneficiary-details.component';
import { TubewellConnectionDashboardComponent } from './components/tubewell-connection-dashboard/tubewell-connection-dashboard.component';
import { OwnMiFarmerGuardGuard } from './guards/own-mi-farmer-guard.guard';
import { EpcWorkApprovalComponent } from './components/department/epc/epc-work-approval/epc-work-approval.component';
import { EpcWorkPvComponent } from './components/department/epc/epc-work-pv/epc-work-pv.component';
import { KrishiMapperComponent } from './components/department/krishi-mapper/krishi-mapper.component';
import { UhbvnNocUploadComponent } from './components/department/uhbvn/uhbvn-noc-upload/uhbvn-noc-upload.component';
import { NewRegistrationComponent } from './components/registration/new-registration/new-registration.component';
import { UhbvnComponent } from './components/department/uhbvn/uhbvn.component';
import { PrintNocComponent } from './components/department/uhbvn/print-noc/print-noc.component';
import { FarmerRequestForNocComponent } from './components/department/uhbvn/farmer-request-for-noc/farmer-request-for-noc.component';
import { UploadedNocForSurveyComponent } from './components/department/uhbvn/uploaded-noc-for-survey/uploaded-noc-for-survey.component';
import { ConsolidatedDashboardComponent } from './components/department/reports/consolidated-report/consolidated-dashboard/consolidated-dashboard.component';
import { VendorDetailsComponent } from './components/registration/vendor-details/vendor-details.component';
import { VendorRegistrationComponent } from './components/vendor-registration/vendor-registration.component';
import { VendorBudgetDetailsComponent } from './components/registration/vendor-budget-details/vendor-budget-details.component';
import { VendorRegGuard } from './guards/vendor-reg.guard';
import { EpcPaymentComponent } from './components/department/epc/epc-payment/epc-payment.component';
import { PfmsPaymentStatusComponent } from './components/department/epc/epc-payment/pfms-payment-status/pfms-payment-status.component';
import { EpcPvDoneComponent } from './components/department/epc/epc-payment/epc-pv-done/epc-pv-done.component';
import { ReadyForPaymentComponent } from './components/department/epc/epc-payment/ready-for-payment/ready-for-payment.component';
import { VendorDashboardComponent } from './components/department/reports/vendor-dashboard/vendor-dashboard.component';
import { RankingRatingReportComponent } from './components/department/reports/ranking-rating-report/ranking-rating-report.component';
import { LotConsolidatedReportComponent } from './components/department/reports/lot-consolidated-report/lot-consolidated-report.component';
import { DevTeamGuard } from './guards/dev-team.guard';
import { MiConsolidatedDetailReportComponent } from './components/department/reports/consolidated-report/mi-consolidated-detail-report/mi-consolidated-detail-report.component';
import { PondConsolidatedDetailReportComponent } from './components/department/reports/consolidated-report/pond-consolidated-detail-report/pond-consolidated-detail-report.component';
import { BenificiaryComponent } from './components/benificiary/benificiary/benificiary.component';
import { SubsidyToVendorAtalComponent } from './components/department/subsidy-lot/subsidy-to-vendor-atal/subsidy-to-vendor-atal.component';
import { VendorRegistrationsComponent } from './components/vendor-registrations/vendor-registrations.component';
import { VendorDataComponent } from './components/je/vendor-data/vendor-data.component';
import { VendorSignupComponent } from './components/registration/vendor-signup/vendor-signup.component';
import { GrievanceComponent } from './components/grievance/grievance.component';
import { GrievanceHandlerComponent } from './components/grievance/grievance-handler/grievance-handler.component';
import { GrievanceHandlerGuard } from './guards/grievance-handler.guard';
import { WebadminGuard } from './guards/webadmin.guard';
import { CaoFinancialDetailsComponent } from './components/cao/cao-financial-details/cao-financial-details.component';
import { JeActivityComponent } from './components/je-activity/je-activity.component';
import { VendorPersonalDetailsComponent } from './components/registration/vendor-personal-details/vendor-personal-details.component';
import { SubsidyDistributionComponent } from './components/cao/subsidy-distribution/subsidy-distribution.component';
import { SubdidyDetailsComponent } from './components/subdidy-details/subdidy-details.component';
import { VendorSubsidyDetailsComponent } from './components/vendor-subsidy-details/vendor-subsidy-details.component';
import { VendorAllApplicationsComponent } from './components/vendor/vendor-all-applications/vendor-all-applications.component';
import { JeSurveyActionInfoComponent } from './components/department/je-survey-action-info/je-survey-action-info.component';
import { MiPondTargetComponent } from './components/target/mi-pond-target/mi-pond-target.component';
import { EpcEstimationDetailsComponent } from './components/department/reports/epc-report/epc-estimation-details/epc-estimation-details.component';
import { PhotoGalleryComponent } from './components/gallery/photo-gallery/photo-gallery.component';
import { VideoGalleryComponent } from './components/gallery/video-gallery/video-gallery.component';
import { SuccessStoriesComponent } from './components/landing/success-stories/success-stories.component';
import { UpdateJamabandiComponent } from './components/dev/update-jamabandi/update-jamabandi.component';
import { AppealComponent } from './components/registration/appeal/appeal.component';
import { VendorPriceRateForApprovalComponent } from './components/department/vendor-price-rate-for-approval/vendor-price-rate-for-approval.component';
import { VendorRegForgotPasswordComponent } from './components/registration/vendor-reg-forgot-password/vendor-reg-forgot-password.component';
import { AdminGuardGuard } from './guards/admin-guard.guard';
import { InsertVendorAssociateComponent } from './components/vendor/insert-vendor-associate/insert-vendor-associate.component';
import { ApprovalVendorAssociateComponent } from './components/vendor/approval-vendor-associate/approval-vendor-associate.component';
import { SubsidyToVendorPfmsEsparshComponent } from './components/cao/subsidy-to-vendor-pfms-esparsh/subsidy-to-vendor-pfms-esparsh.component';
import { ESparshPaymentComponent } from './components/department/epc/epc-payment/e-sparsh-payment/e-sparsh-payment.component';
import { UserMappingComponent } from './components/user-mapping/user-mapping.component';
import { ApplicationWorkFlowDiagComponent } from './components/application-work-flow/application-work-flow-diag/application-work-flow-diag.component';
import { SubsidyToFarmerPfmsEsparshComponent } from './components/cao/subsidy-to-farmer-pfms-esparsh/subsidy-to-farmer-pfms-esparsh.component';
import { EpcGeneratedLotUploadTaxComponent } from './components/department/epc/epc-generated-lot-upload-tax/epc-generated-lot-upload-tax.component';
import { TankStage1PfmsESparshComponent } from './components/cao/tank-stage1-pfms-e-sparsh/tank-stage1-pfms-e-sparsh.component';
import { TankStage2PfmsESparshComponent } from './components/cao/tank-stage2-pfms-e-sparsh/tank-stage2-pfms-e-sparsh.component';
import { TankStage3PfmsESparshComponent } from './components/cao/tank-stage3-pfms-e-sparsh/tank-stage3-pfms-e-sparsh.component';
import { CompleteUserListComponent } from './components/complete-user-list/complete-user-list.component';
import { DaWisePendingReportComponent } from './components/department/reports/da-wise-pending-report/da-wise-pending-report.component';
import { OfflinePaymentSheetEpcComponent } from './components/department/epc/epc-payment/offline-payment-sheet-epc/offline-payment-sheet-epc.component';
import { PastSubsidyDataComponent } from './components/application/past-subsidy-data/past-subsidy-data.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: LoginComponent }],
    pathMatch: 'full',
  },
  {
    path: 'forgot-password',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: ForgotPasswordComponent }],
    pathMatch: 'full',
  },
  {
    path: 'phone-login',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: PhoneLoginComponent }],
    pathMatch: 'full',
  },
  {
    path: 'vendor-registration-login',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: VendorRegistrationComponent }],
    pathMatch: 'full',
  },
  {
    path: 'vendor-reg/forgot-password',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: VendorRegForgotPasswordComponent }],
    pathMatch: 'full',
  },
  // {
  //   path: 'vendor-reg-signup',
  //   component: HomePageLayoutComponent,
  //   children: [{ path: '', component: VendorSignupComponent }],
  //   pathMatch: 'full',
  // },
  {
    path: 'tubewell-connection-login',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: TubewellConnectionLoginComponent }],
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: LandingComponent }],
  },
  {
    path: 'photo-gallery',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: PhotoGalleryComponent }],
  },
  {
    path: 'video-gallery',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: VideoGalleryComponent }],
  },
  {
    path: 'success-stories',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: SuccessStoriesComponent }],
  },
  {
    path: 'activities',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'officeOrders',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: OfficeOrdersComponent }],
  },
  {
    path: 'org-setup',
    component: OrganizationalSetupComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'beneficiary',
    component: BeneficiaryDetailsComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'rti',
    component: RtiComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'statistics',
    component: StatisticsComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'new-initiatives',
    component: NewInitiativesComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'evaluation-study',
    component: EvaluationStudyComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'achievements',
    component: AchievementsComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'annual-plan',
    component: AnnualPlanComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'project',
    component: ProjectComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'new-target',
    component: NewTargetComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'micro-irrigation',
    component: MicroIrrigationComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: '',
    component: InnerPageLayoutComponent,
    canActivate: [OwnMiFarmerGuardGuard],
    children: [
      { path: '', redirectTo: 'tubewell-connection-dashboard', pathMatch: 'full' },
      { path: 'tubewell-connection-dashboard', component: TubewellConnectionDashboardComponent }
    ],
  },
  {
    path: 'farmer',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'pond-progress-intimation', component: PondProgressIntimationComponent },
      { path: 'bank-details', component: BankDetailsComponent },
      { path: 'personal-details', component: PersonalDetailsComponent },
      { path: 'farmer-land-detail', component: FarmerLandDetailComponent },
      { path: 'on-farm-mi', component: OnFarmMiComponent },
      // { path: 'farmers-application', component: FarmersApplicationComponent },
      { path: 'farmers-application/:appId', component: FarmersApplicationComponent },
      { path: 'dashboard/print', component: ConsentFormComponent },
      { path: 'dashboard/print/:appId', component: ConsentFormComponent },
      { path: 'dashboard/print/:appId/:vendorId/:programId/:userId/:autoId', component: ConsentFormComponent },
      {
        path: 'challan',
        children: [
          { path: '', redirectTo: 'mi-challan', pathMatch: 'full' },
          { path: 'mi-challan', component: MiChallanComponent },
          { path: 'sanction-letter/:id/:programId', component: SanctionLetterComponent },
          { path: 'farmer-share/:id/:pId', component: FarmerShareComponent },
          { path: 'full-payment/:id/:pId', component: FullPaymentComponent },
          { path: 'solar-challan', component: SolarChallanComponent },
        ],
      },
      {
        path: 'sanction',
        children: [
          { path: '', redirectTo: 'sanctio-letter-comp', pathMatch: 'full' },
          { path: 'sanctio-letter-comp', component: SanctionLetterComponentComponent },
          { path: 'sanction-letter/:id/:programId', component: SanctionLetterComponent },
        ],
      },
      {
        path: 'change-request',
        children: [{ path: '', component: ChangeRequestComponent }],
      },
      {
        path: 'change-details',
        component: ChangeVendorComponent
      },
      {
        path: 'new-registration',
        children: [{ path: '', component: NewRegistrationComponent }],
      },
      {
        path: 'grievance',
        children: [{ path: '', component: GrievanceComponent }],
      },
      { 
        path: 'workflowstatus', component:ApplicationWorkFlowDiagComponent
      },
    ],
  },

  {
    path: 'new-registration',
    component: InnerPageLayoutComponent,
    canActivate: [VendorRegGuard],
    children: [
      { 
        path: '', redirectTo: 'budget-Details', pathMatch: 'full' 
      },
      // { path: 'vendor-details', component: VendorDetailsComponent },
      {
        path:'budget-Details', component:VendorBudgetDetailsComponent
      },
      {
        path:'reg-deatils',component:VendorPersonalDetailsComponent
      },
      {
        path:'appeal-deatils',component:AppealComponent
      },
    ],
  },

  {
    path: 'department',
    component: InnerPageLayoutComponent,
    canActivateChild: [DepartmentGuardGuard],
    children: [
      // {
      //   path: 'farmer-applications',
      //   component: FarmerApplicationVerificationComponent,
      // },
      {
        path: 'farmer-applications',
        component: FarmerApplicationVerificationComponent,
        
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: FarmerApplicationVerificationPendingComponent,
          },
          {
            path: 'current',
            component: FarmerApplicationVerificationCurrentComponent,
          },
          {
            path: 'approved',
            component: FarmerApplicationVerificationCompletedComponent,
          },
        ],
      },
      // { path: 'farmer-applications/all-status/:id', component: WorkFlowAllStatusComponent },
      // {
      //   path: 'vendor-mi-applications',
      //   component: MiVendorApplicationVerificationComponent,
      // },
      {
        path: 'vendor-mi-applications',
        component: MiVendorApplicationVerificationComponent,
        
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: MiVendorApplicationVerificationPendingComponent,
          },
          {
            path: 'current',
            component: MiVendorApplicationVerificationCurrentComponent,
          },
          {
            path: 'approved',
            component: MiVendorApplicationVerificationApprovedComponent,
          },
        ],
      },
      {
        path: 'tank-stage1',
          component: TankStage1Component,
          children: [
              { path: '', redirectTo: 'pending', pathMatch: 'full' },
              { path: 'pending', component: TankStage1PendingComponent },
              { path: 'current', component: TankStage1CurrentComponent },
              { path: 'approved', component: TankStage1ApprovedComponent },
          ],
      },
      {
        path: 'tank-stage2',
          component: TankStage2Component,
          children: [
              { path: '', redirectTo: 'pending', pathMatch: 'full' },
              { path: 'pending', component: TankStage2PendingComponent },
              { path: 'current', component: TankStage2CurrentComponent },
              { path: 'approved', component: TankStage2ApprovedComponent },
          ],
      },
      {
        path: 'tank-stage3',
          component: TankStage3Component,
          children: [
              { path: '', redirectTo: 'pending', pathMatch: 'full' },
              { path: 'pending', component: TankStage3PendingComponent },
              { path: 'current', component: TankStage3CurrentComponent },
              { path: 'approved', component: TankStage3ApprovedComponent },
          ],
      },
      {
        path: 'print-farmer-bank-challan',
        component: PrintFarmersChallanComponent,
      },
      {
        path: 'approve-farmer-bank-challan',
        component: ApproveFarmersChallanComponent,
      },
      {
        path: 'year-wise-progress',
        component : YearWiseProgressComponent
      },
      {
        path: 'mi-area-covered',
        component : MiAreaCoveredComponent
      },
      {
        path: 'realtime-data-pdmc-scheme',
        component: RealtimeDataPdmcSchemeComponent
      },
      {
        path: 'vendor-estimate/print/:appId/:vendorId/:programId',
        component: VendorMiEstimationConsentFormComponent,
      },
      {
        path: 'vendor-estimate/print',
        component: VendorMiEstimationConsentFormComponent,
      },
      {
        path: 'appliaction-approval/print/:appId',
        ///:vendorId/:programId/:userId/:autoId
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'appliaction-approval/print',
        ///:vendorId/:programId/:userId/:autoId
        component: DepartmentConsentFormComponent,
      },
      // {
      //   path: 'print/:appId',
      //   ///:vendorId/:programId/:userId/:autoId
      //   component: DepartmentConsentFormComponent,
      // },
      {
        path: 'report-summary',
        component: ReportSummaryComponent,
      },
      {
        path:'helpdesk',
        component: HelpdeskComponent,
      },
      {
        path: 'helpdesk/view',
        component: ConsentFormComponent,
      },
      {
        path: 'mi-survey',
        component: MiSurveyComponent,
      },
      {
        path: 'farmer-share-to-vendor',
        component: FarmerShareToVendorComponent,
      },
      {
        path: 'subsidy-to-vendor',
        component: SubsidyToVendorComponent,
      },
      {
        path: 'subsidy-to-vendor-aby',
        component: SubsidyToVendorAtalComponent,
      },
      {
        path: 'subsidy-to-farmer',
        component: SubsidyToFarmerComponent,
      },
      {
        path: 'subsidy-to-farmer-aby',
        component: SubsidyToFarmerAtalComponent,
      },
      {
        path: 'refund-to-farmer',
        component: RefundToFarmerComponent,
      },
      {
        path: 'update-mi-component-cml-validity',
        component: UpdateMiComponentCmlValidityComponent,
      },
      // {
      //   path: 'physical-verification',
      //   component: MiPhysicalVerificationsComponent,
      // },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print',
        component: ViewFarmerApplicationComponent,
      },
      {
        path:'pond/tankstage-1',
        component: Tankstagesurvey1Component,
      },
      {
        path:'pond/tankstage-2',
        component: Tankstagesurvey2Component,
      },
      {
        path:'pond/tankstage-3',
        component: Tankstagesurvey3Component,
      },
      { 
        path: 'esparsh-payment', 
        component: ESparshPaymentComponent 
      },
      { 
        path: 'epc-payment-status', 
        component: PfmsPaymentStatusComponent 
      },
      // {
      //   path:'dashboard',
      //   component: DepartmentDashboardComponent,
      // },
      // {
      //   path: 'report/challan-report-by-vendor',
      //   component : ChallanReportByVendorIdComponent
      // },
      
      // {
      //   path: 'dashboard/micada_geography',
      //   component: DepartmentDashboardComponent,
      //   pathMatch: 'full'
      // },
      // {
      //   path: 'dashboard/vendor_metrics',
      //   component: DepartmentDashboardComponent,
      //   pathMatch: 'full'
      // },
      // {
      //   path: 'dashboard/app_verification',
      //   component: DepartmentDashboardComponent,
      //   pathMatch: 'full'
      // },
      {
        path: 'application',
        component: JeApplicationComponent,
        children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
          { path: 'image-attachment', component: ImageAttachmentsComponent },
        ],
      },
      { path: 'change-request', component: FarmerAppChangeRequestComponent },
      { path: 'maps', component: ViewCoOrdinatesComponent, pathMatch: 'full' },
      {
        path: 'report/app-verification',
        component: AppVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: MonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: DistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: UserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: VendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/boq',
        component: BOQReportComponent,
        
        children: [
          { path: '', redirectTo: 'boq-month-wise', pathMatch: 'full' },
          {
            path: 'boq-month-wise',
            component: BoqMonthWiseReportComponent,
          },
          {
            path: 'boq-district-wise',
            component: BoqDistrictWiseReportComponent,
          },
          {
            path: 'boq-mi-type',
            component: BoqMiTypeReportComponent,
          },
          {
            path: 'boq-vendor-wise',
            component: BoqVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation-verification',
        component: EstimationVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: EstVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: EstVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: EstVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: EstVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/challan',
        component: ChallanReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: ChallanDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: ChallanVendorWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: ChallanMonthWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/physical-verification',
        component: PhysicalVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PhysicalVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PhysicalVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PhysicalVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PhysicalVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/fsv',
        component: FsvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: FsvMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: FsvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: FsvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stv',
        component: StvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: StvMonthWiseComponent,
          },
          {
            path: 'district-wise',
            component: StvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stf',
        component: StfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: StfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: StfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/rtf',
        component: RtfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: RtfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: RtfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: RtfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/mi-verification-subsidy-report',
        component: MiVerificationSubsidyReportComponent,     
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/tank-abstract-report',
        component: TankAbstractReportComponent,     
      },
      // {
      //   path: 'report/stage1-report',
      //   component: Stage1ReportComponent,
        
      // },
      // {
      //   path: 'report/stage2-report',
      //   component: Stage2ReportComponent,
        
      // },
      // {
      //   path: 'report/stage3-report',
      //   component: Stage3ReportComponent,
        
      // },
      // {
      //   path: 'report/stage1-subsidy-report',
      //   component: Stage1SubsidyReportComponent,
        
      // },
      // {
      //   path: 'report/stage2-subsidy-report',
      //   component: Stage2SubsidyReportComponent,
        
      // },
      // {
      //   path: 'report/stage3-subsidy-report',
      //   component: Stage3SubsidyReportComponent,
        
      // },
      {
        path: 'report/canal-and-tube-well-based-report',
        component: CanalAndTubeWellBasedReportComponent,
        
      },
      {
        path: 'report/7500-demo',
        component: SeventyFiveHundredDemoComponent,
        
      },
      {
        path: 'report/atal-bhujal-user',
        component: AtalUserComponent,
      },
      {
        path: 'report/subsidy-wise-report',
        component: SubsidyWiseReportComponent
      },
      {
        path: 'report/financial-details',
        component: CaoFinancialDetailsComponent, 
      },
      {
        path: 'report/subsidy-disbursed',
        component: SubsidyDistributionComponent, 
      },
      {
        path: 'report/chalan-reconciliation-day-report',
        component: ChallanReconciliationDayReportComponent,     
      },
      {
        path: 'report/lot-wise-report',
        component: LotWiseReportComponent,
        
        children: [
          // { path: '', redirectTo: 'fsv', pathMatch: 'full' },
          { path: 'fsv', component: FsvLotReportComponent, pathMatch: 'full' },
          { path: 'stf', component: StfLotReportComponent, pathMatch: 'full' },
          { path: 'stv', component: StvLotReportComponent, pathMatch: 'full' },
          { path: 'rtf', component: RtfLotReportComponent, pathMatch: 'full' },
          { path: 'stage1', component: Stage1LotReportComponent, pathMatch: 'full' },
          { path: 'stage2', component: Stage2LotReportComponent, pathMatch: 'full' },
          { path: 'stage3', component: Stage3LotReportComponent, pathMatch: 'full' },
        ],
      },
      {
        path: 'report/lot-report',
        component: LotReportComponent,     
      },
      {
        path: 'report/lot-consolidated-report',
        component: LotConsolidatedReportComponent,     
      },
      {
        path: 'all-subsidy-lot',
        component: AllSubsidyLotComponent,
        
        children: [
          // { path: '', redirectTo: 'mi-farmer-share-to-vendor/pdmc', pathMatch: 'full' },
          { path: 'mi-farmer-share-to-vendor/pdmc', component: FarmerShareToVendorPfmsReportComponent, pathMatch: 'full' },
          // { path: 'mi-farmer-share-to-farmer/aby', component: FarmerShareToFarmerPfmsReportComponent, pathMatch: 'full' },
          { path: 'mi-subsidy-to-farmer/pdmc', component: SubsidyToFarmerPfmsReportComponent, pathMatch: 'full' },
          { path: 'mi-subsidy-to-farmer/aby', component: SubsidyToFarmerAbyPfmsReportComponent, pathMatch: 'full' },
          { path: 'mi-subsidy-to-farmer-esparsh', component: SubsidyToFarmerPfmsEsparshComponent, pathMatch: 'full' },
          { path: 'mi-subsidy-to-vendor/pdmc', component: SubsidyToVendorPfmsReportComponent, pathMatch: 'full' },
          { path: 'mi-subsidy-to-vendor-esparsh', component: SubsidyToVendorPfmsEsparshComponent, pathMatch: 'full' },
          { path: 'mi-subsidy-to-vendor/aby', component: SubsidyToVendorAbyPfmsReportComponent, pathMatch: 'full' },
          { path: 'mi-refund-to-farmer/pdmc', component: ReturnToFarmerPfmsReportComponent, pathMatch: 'full' },
          // { path: 'mi-refund-to-farmer/aby', component: RefundToFarmerAbyComponent, pathMatch: 'full' },

          // { path: 'mi-farmer-share-to-vendor/pfms', component: FarmerShareToVendorPfmsReportComponent,  },
          // { path: 'mi-subsidy-to-farmer/pfms', component: SubsidyToFarmerPfmsReportComponent,  },
          // { path: 'mi-subsidy-to-vendor/pfms', component: SubsidyToVendorPfmsReportComponent, },
          // { path: 'mi-refund-to-farmer/pfms', component: ReturnToFarmerPfmsReportComponent,  },
          { path: 'import/pfms', component: ImportPfmsDataComponent,  },
          
          { path: 'pond/tank-stage1/pdmc', component: TankStage1PfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage1/aby', component: TankStage1AbyPfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage2/pdmc', component: TankStage2PfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage2/aby', component: TankStage2AbyPfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage3/pdmc', component: TankStage3PfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage3/aby', component: TankStage3AbyPfmsReportComponent, pathMatch: 'full' },
        ],
      },
      {
        path: 'failed-mi-payment',
        component: FailedMiPaymentComponent,
        
        children: [
          // { path: '', redirectTo: 'mi-farmer-share-to-vendor/pdmc', pathMatch: 'full' },
          { path: 'fsv', component: FailedMiPaymentFsvComponent, pathMatch: 'full' },
          { path: 'stf', component: FailedMiPaymentStfComponent, pathMatch: 'full' },
          { path: 'stv', component: FailedMiPaymentStvComponent, pathMatch: 'full' },
          { path: 'rtf', component: FailedMiPaymentRtfComponent, pathMatch: 'full' },
        ],
      },
      // {
      //   path: 'failed-pond-payment',
      //   component: FailedPondPaymentComponent,
        
      //   children: [
      //     // { path: '', redirectTo: 'mi-farmer-share-to-vendor/pdmc', pathMatch: 'full' },
      //     { path: 'stage1', component: FailedPondPaymentS1Component, pathMatch: 'full' },
      //     { path: 'stage2', component: FailedPondPaymentS2Component, pathMatch: 'full' },
      //     { path: 'stage3', component: FailedPondPaymentS3Component, pathMatch: 'full' },
      //   ],
      // },
      {
        path: 'report/chalan-reconciliation-day-report',
        component: ChallanReconciliationDayReportComponent,     
      },
      {
        path: 'mi-physical-location',
        component: MiPhysicalLocationComponent
      },
      {
        path: 'report/user-wise-pending-report',
        component: DaWisePendingReportComponent
      },
      {
        path: 'report/da-report',
        component: DaReportComponent,
        
        children: [
          // { path: '', redirectTo: 'mi', pathMatch: 'full' },
          {
            path: 'mi',
            component: MiDaReportComponent,
          },
          {
            path: 'pond',
            component: PondDaReportComponent,
          },
         
        ],
      },
      {
        path: 'report/pre-estimation',
        component: VendorPreEstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PreEstimateMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PreEstimateDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PreEstimateUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PreEstimateVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/consolidated-report',
        component: ConsolidatedReportComponent,
      },
      {
        path: 'report/consolidated-report-new',
        component: ConsolidatedDashboardComponent,     
      },
      {
        path: 'report/mi-total-app-report',
        component: MiConsolidatedTotalAppReportComponent,
      },
      {
        path: 'report/mi-consolidated-details',
        component: MiConsolidatedDetailReportComponent,
      },
      {
        path: 'report/pond-total-app-report',
        component: PondConsolidateReportComponent,
      },
      {
        path: 'report/pond-consolidated-details',
        component: PondConsolidatedDetailReportComponent,
      },
      {
        path: 'report/consolidated-report/:actionType/:finYear',
        component: MiConsolidatedCountWiseReportComponent,
      },
      {
        path: 'report/pond-report/:actionType/:finYear',
        component: PondCountWiseReportComponent, 
      },
      {
        path: 'report/timeline',
        component: ApplicationTypeReportComponent
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'report/inventory-report',
        component: InventoryReportComponent,

      },
      {
        path: 'report/print/:appId',
        component: DepartmentConsentFormComponent,
      },
      { 
        path: 'physical-fin-target', 
        component: PhysicalFinTargetComponent
      },
      { 
        path: 'krishi-mapper', 
        component: KrishiMapperComponent
      },
      // {
      //   path: 'change-program',
      //   component: ChangeProgramComponent
      // },
      {
        path: 'unhide-application',
        component: UnhideApplicationComponent
      },
      // {
      //   path: 'change-details',
      //   component: ChangeVendorComponent
      // },
      { 
        path: 'canal', 
        component: CanalTargetComponent 
      },
      { 
        path: 'stp', 
        component: StpTargetComponent 
      },
      { 
        path: 'overflow-pond', 
        component: OverFlowPondComponent 
      },
      { 
        path: 'crop-master', 
        component: CropMasterStatusComponent 
      },
      { 
        path: 'mi-pond-target', 
        component: MiPondTargetComponent 
      },
      {
        path: 'vendor-registration',
        component: VendorRegistrationsComponent
      },
      {
        path: 'vendor-price-details',
        component: VendorPriceRateForApprovalComponent
      },
      { path: 'vendor-data', 
        component: VendorDataComponent 
      },
      { 
        path: 'associate-approval', 
        component: ApprovalVendorAssociateComponent 
      },
    ],
    
  },
  {
    path: 'vendor',
    component: InnerPageLayoutComponent,
    canActivateChild: [VendorGuardGuard],
    children: [
      { path: '', redirectTo: 'pre-estimate-survey', pathMatch: 'full' },
      // { path: 'dashboard', component: VendorComponent },
      
          // {
          //   path: 'dashboard/dashoard-report-new',
          //   component: VendorDashboardComponent,
          // },
          // {
          //   path: 'print/:appId',
          //   component: ViewFarmerApplicationComponent,
          // },
      // { path: 'dashboard', component: VendorComponent },
      {  path: 'dashboard/dashoard-report-new',  component: VendorDashboardComponent },
      {  path: 'print/:appId',  component: ViewFarmerApplicationComponent},
      {  path: 'print',  component: ViewFarmerApplicationComponent},
      {  path: 'report/mi-consolidated-details',  component: MiConsolidatedDetailReportComponent},
    
      {
        path: 'vendor-farmer-application',
        component: VendorFarmerApplicationComponent,
      },
      // {
      //   path:'helpdesk',
      //   component: HelpdeskComponent,
      // },
      // {
      //   path: 'helpdesk/:appId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'benificiary',
        component:BenificiaryComponent
      },
      {
        path: 'grievance',
        component: GrievanceComponent
      },
      // {
      //   path: 'vendor-BOQ',
      //   component: VendorBOQComponent,
      // },
      {
        path: 'vendor-BOQ',
        component: VendorBOQComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: VendorBoqPendingComponent,
          },
          {
            path: 'approved',
            component: VendorBoqApprovedComponent,
          },
          {
            path: 'current',
            component: VendorBoqCurrentComponent,
          },
        ],
      },
      {
        path: 'vendor-application',
        component: VendorApplicationComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: VendorAppPendingComponent,
          },
          {
            path: 'approved',
            component: VendorAppApprovedComponent,
          },
          {
            path: 'current',
            component: VendorAppCurrentComponent,
          },
          
         
        ],
      },
      {
        path: 'vendor-FullPaymentChallanDetails',
        component: FullPaymentchallanDetailsComponent,
      },
      // {
      //   path: 'print/:appId/:vendorId/:programId',
      //   component: VendorConsentFormComponent,
      // },
      {
        path: 'print/:appId',
        component: VendorConsentFormComponent,
      },
      {
        path: 'print',
        component: VendorConsentFormComponent,
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/vendor-subsidy-details',
        component: VendorSubsidyDetailsComponent,

      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          }
        ],
      },
      {
        path: 'pre-estimate-survey',
        component: PreEstimateSurveyComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: PreEstimateSurveyPendingComponent,
          },
          {
            path: 'approved',
            component: PreEstimateSurveyApprovedComponent,
          },
          {
            path: 'current',
            component: PreEstimateSurveyCurrentComponent,
          },  
        ],
      },
      {
        path:'mi-component-inventory-details',
        component: MiInventoryDetailsComponent
      },
      {
        path:'upload-gst-details',
        component: UploadGstComponent
      },
      {
        path:'report/challan-report-by-vendor',
        component: ChallanReportByVendorIdComponent
      },
      {
        path:'report/vendor-subsidy-detailsr',
        component: VendorSubsidyDetailsComponent
      },
      {
        path: 'vendor-all-applications',
        component: VendorAllApplicationsComponent,
      },
      {
        path: 'add-vendor-associate',
        component: InsertVendorAssociateComponent,
      },
      {
        path: 'past-subsidy-data',
        component: PastSubsidyDataComponent,
      },
    ],
  },
  {
    path: 'je',
    component: InnerPageLayoutComponent,
    canActivateChild: [JEGuardGuard],
    children: [
      // { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      // { path: 'dashboard', component: PondEstimateComponent },
     { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },
    {
      path: 'physical-verification',
      component: MiPhysicalVerificationsComponent,
      children: [
        { path: '', redirectTo: 'pending', pathMatch: 'full' },
        { path: 'pending', component: MiPhysicalVerificationPendingComponent },
        { path: 'current', component: MiPhysicalVerificationCurrentComponent },
        { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
      ],
    },
      // {
      //   path: 'physical-verification',
      //   component: MiPhysicalVerificationsComponent,
      // },
      // {
      //   path: 'physical-verification/:appId/:vendorId/:programId/:userId/:autoId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'tank-stage1',
        component: TankStage1Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage1PendingComponent },
          { path: 'current', component: TankStage1CurrentComponent },
          { path: 'approved', component: TankStage1ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage2',
        component: TankStage2Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage2PendingComponent },
          { path: 'current', component: TankStage2CurrentComponent },
          { path: 'approved', component: TankStage2ApprovedComponent },
        ],
      },
      // {
      //   path: 'tank-stage3',
      //   component: TankStage3Component,
      //   children: [
      //     { path: '', redirectTo: 'pending', pathMatch: 'full' },
      //     { path: 'pending', component: TankStage3PendingComponent },
      //     { path: 'current', component: TankStage3CurrentComponent },
      //     { path: 'approved', component: TankStage3ApprovedComponent },
      //   ],
      // },
      {
        path: 'application',
        component: JeApplicationComponent,
        children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ],
      },
      // {
      //   path: 'print/:appId', component: VendorConsentFormComponent,
      // }
      {
        path: 'mi-source-location',
        component: MiSourceLocationComponent
      },
      {
        path: 'epc/work-pv', component: EpcWorkPvComponent
      },
      {
        path: 'uhbvn/farmer-request-noc', component: FarmerRequestForNocComponent
      },
      {
        path: 'uhbvn/uploaded-noc-survey', component: UploadedNocForSurveyComponent
      },
      {
        path: 'assignment-plan', component: JeSurveyActionInfoComponent
      },
      // {
      //   path:'helpdesk',
      //   component: HelpdeskComponent,
      // },
      // {
      //   path: 'helpdesk/:appId',
      //   component: ConsentFormComponent,
      // },
    ],
  },

  {
    path: 'cje',
    component: InnerPageLayoutComponent,
    canActivateChild: [JEGuardGuard],
    children: [
     { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },
    //  { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
    {
      path: 'physical-verification',
      component: MiPhysicalVerificationsComponent,
      children: [
        { path: '', redirectTo: 'pending', pathMatch: 'full' },
        { path: 'pending', component: MiPhysicalVerificationPendingComponent },
        { path: 'current', component: MiPhysicalVerificationCurrentComponent },
        { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
      ],
    },
    {
      path: 'print/:appId',
      component: ConsentFormComponent,
    }, 
    {
      path: 'print',
      component: ConsentFormComponent,
    }, 
    {
      path: 'application',
      component: JeApplicationComponent,
      children: [
        { path: '', redirectTo: 'basic', pathMatch: 'full' },
        { path: 'basic', component: BasicComponent },
        { path: 'finance', component: FinanceComponent },
        { path: 'attachment', component: AttachmentComponent },
      ],
    },
    ],
  },

  {
    path: 'sdo',
    component: InnerPageLayoutComponent,
    canActivateChild: [SdoGuardGuard],
    children: [
      { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },

      // { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      // {
      //   path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'print/:appId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'print',
        component: ConsentFormComponent,
      }, 
      {
        path: 'tank-stage1',
        component: TankStage1Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage1PendingComponent },
          { path: 'current', component: TankStage1CurrentComponent },
          { path: 'approved', component: TankStage1ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage2',
        component: TankStage2Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage2PendingComponent },
          { path: 'current', component: TankStage2CurrentComponent },
          { path: 'approved', component: TankStage2ApprovedComponent },
        ],
      },
      // {
      //   path: 'tank-stage3',
      //   component: TankStage3Component,
      //   children: [
      //     { path: '', redirectTo: 'pending', pathMatch: 'full' },
      //     { path: 'pending', component: TankStage3PendingComponent },
      //     { path: 'current', component: TankStage3CurrentComponent },
      //     { path: 'approved', component: TankStage3ApprovedComponent },
      //   ],
      // },
      // {
      //   path: 'sdo/tank-stage3',
      //   component: TankStage3Component,
      // },
      {
        path: 'application', component: JeApplicationComponent, children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ]
      },

      {
        path: 'view-form',
        component: ViewFormComponent,
      },
      {
        path: 'report/user-wise-pending-report',
        component: DaWisePendingReportComponent
      },
    ],
  },
  {
    path: 'xen',
    component: InnerPageLayoutComponent,
    canActivateChild: [XenGuardGuard],
    children: [
      { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },

      // { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'print/:appId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'print',
        component: ConsentFormComponent,
      }, 
      {
        path: 'tank-stage1',
        component: TankStage1Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage1PendingComponent },
          { path: 'current', component: TankStage1CurrentComponent },
          { path: 'approved', component: TankStage1ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage2',
        component: TankStage2Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage2PendingComponent },
          { path: 'current', component: TankStage2CurrentComponent },
          { path: 'approved', component: TankStage2ApprovedComponent },
        ],
      },
      // {
      //   path: 'tank-stage3',
      //   component: TankStage3Component,
      //   children: [
      //     { path: '', redirectTo: 'pending', pathMatch: 'full' },
      //     { path: 'pending', component: TankStage3PendingComponent },
      //     { path: 'current', component: TankStage3CurrentComponent },
      //     { path: 'approved', component: TankStage3ApprovedComponent },
      //   ],
      // },
      // {
      //   path: 'xen/tank-stage3',
      //   component: TankStage3Component,
      // },
      { path: 'vendor-data', component: VendorDataComponent },
      {
        path: 'application', component: JeApplicationComponent, children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ]
      },
      {
        path: 'uhbvn', component: UhbvnComponent, children: [
          { path: '', redirectTo: 'upload-noc', pathMatch: 'full' },
          { path: 'upload-noc', component: UhbvnNocUploadComponent },
          { path: 'uploaded-noc-survey', component: UploadedNocForSurveyComponent },
        ]
      },
      {
        path: 'epc', component: EpcPaymentComponent, children: [
          { path: '', redirectTo: 'pv-done', pathMatch: 'full' },
          { path: 'pv-done', component: EpcPvDoneComponent },
          { path: 'offline-payment-sheet', component: OfflinePaymentSheetEpcComponent },
          { path: 'ready-for-payment', component: ReadyForPaymentComponent },
          { path: 'epc-generated-lot', component: EpcGeneratedLotUploadTaxComponent },
        ]
      },
      { 
        path: 'uhbvn/print-noc', component: PrintNocComponent 
      },
      { 
        path: 'uhbvn/farmer-request-noc', component: FarmerRequestForNocComponent 
      },
      {
        path: 'epc/work-approval', component: EpcWorkApprovalComponent
      },
      {
        path: 'view-form',
        component: ViewFormComponent,
      },
      // {
      //   path:'helpdesk',
      //   component: HelpdeskComponent,
      // },
      // {
      //   path: 'helpdesk/:appId',
      //   component: ConsentFormComponent,
      // },
      {
        path:'jeActivity',
        component: JeActivityComponent,
      },
      {
        path: 'report/app-verification',
        component: AppVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: MonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: DistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: UserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: VendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/boq',
        component: BOQReportComponent,
        
        children: [
          { path: '', redirectTo: 'boq-month-wise', pathMatch: 'full' },
          {
            path: 'boq-month-wise',
            component: BoqMonthWiseReportComponent,
          },
          {
            path: 'boq-district-wise',
            component: BoqDistrictWiseReportComponent,
          },
          {
            path: 'boq-mi-type',
            component: BoqMiTypeReportComponent,
          },
          {
            path: 'boq-vendor-wise',
            component: BoqVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation-verification',
        component: EstimationVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: EstVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: EstVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: EstVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: EstVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/challan',
        component: ChallanReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: ChallanDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: ChallanVendorWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: ChallanMonthWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/physical-verification',
        component: PhysicalVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PhysicalVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PhysicalVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PhysicalVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PhysicalVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/fsv',
        component: FsvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: FsvMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: FsvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: FsvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stv',
        component: StvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: StvMonthWiseComponent,
          },
          {
            path: 'district-wise',
            component: StvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stf',
        component: StfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: StfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: StfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/rtf',
        component: RtfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: RtfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: RtfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: RtfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/mi-verification-subsidy-report',
        component: MiVerificationSubsidyReportComponent,     
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/tank-abstract-report',
        component: TankAbstractReportComponent,     
      },
      {
        path: 'report/stage1-report',
        component: Stage1ReportComponent,
        
      },
      {
        path: 'report/stage2-report',
        component: Stage2ReportComponent,
        
      },
      {
        path: 'report/stage3-report',
        component: Stage3ReportComponent,
        
      },
      {
        path: 'report/stage1-subsidy-report',
        component: Stage1SubsidyReportComponent,
        
      },
      {
        path: 'report/stage2-subsidy-report',
        component: Stage2SubsidyReportComponent,
        
      },
      {
        path: 'report/stage3-subsidy-report',
        component: Stage3SubsidyReportComponent,
        
      },
      {
        path: 'report/canal-and-tube-well-based-report',
        component: CanalAndTubeWellBasedReportComponent,

      },
      {
        path: 'mi-physical-location',
        component: MiPhysicalLocationComponent
      },
      {
        path: 'report/7500-demo',
        component: SeventyFiveHundredDemoComponent,
      },
      {
        path: 'report/atal-bhujal-user',
        component: AtalUserComponent,
      },
      { 
        path: 'report/estimation-details', 
        component: EpcEstimationDetailsComponent
      },      
    ],
  },
  {
    path: 'cxen',
    component: InnerPageLayoutComponent,
    canActivateChild: [XenGuardGuard],
    children: [
      { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },

      // { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'print/:appId',
        component: ConsentFormComponent,
      },
      {
        path: 'print',
        component: ConsentFormComponent,
      },
      {
        path: 'application', component: JeApplicationComponent, children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ]
      },

      {
        path: 'view-form',
        component: ViewFormComponent,
      },
    ]
  },
  {
    path: 'admin',
    component: InnerPageLayoutComponent,
    canActivateChild: [AdminGuardGuard],
    children: [
      { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },

      // { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      {
        path: 'tank-stage1',
        component: TankStage1Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage1PendingComponent },
          { path: 'current', component: TankStage1CurrentComponent },
          { path: 'approved', component: TankStage1ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage2',
        component: TankStage2Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage2PendingComponent },
          { path: 'current', component: TankStage2CurrentComponent },
          { path: 'approved', component: TankStage2ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage3',
        component: TankStage3Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage3PendingComponent },
          { path: 'current', component: TankStage3CurrentComponent },
          { path: 'approved', component: TankStage3ApprovedComponent },
        ],
      },
      {
        path: 'print',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'year-wise-progress',
        component : YearWiseProgressComponent
      },
      {
        path: 'mi-area-covered',
        component : MiAreaCoveredComponent
      },
      {
        path: 'realtime-data-pdmc-scheme',
        component: RealtimeDataPdmcSchemeComponent
      },
      {
        path: 'application', component: JeApplicationComponent, children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ]
      },

      {
        path: 'view-form',
        component: ViewFormComponent,
      },

      // {
      //   path: 'sdo/tank-stage1',
      //   component: TankStage1Component,
      // },

      // {
      //   path: 'sdo/tank-stage2',
      //   component: TankStage2Component,
      // },

      // {
      //   path: 'sdo/tank-stage3',
      //   component: TankStage3Component,
      // },
      {
        path: 'report/app-verification',
        component: AppVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: MonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: DistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: UserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: VendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/boq',
        component: BOQReportComponent,
        
        children: [
          { path: '', redirectTo: 'boq-month-wise', pathMatch: 'full' },
          {
            path: 'boq-month-wise',
            component: BoqMonthWiseReportComponent,
          },
          {
            path: 'boq-district-wise',
            component: BoqDistrictWiseReportComponent,
          },
          {
            path: 'boq-mi-type',
            component: BoqMiTypeReportComponent,
          },
          {
            path: 'boq-vendor-wise',
            component: BoqVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation-verification',
        component: EstimationVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: EstVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: EstVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: EstVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: EstVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/challan',
        component: ChallanReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: ChallanDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: ChallanVendorWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: ChallanMonthWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/physical-verification',
        component: PhysicalVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PhysicalVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PhysicalVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PhysicalVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PhysicalVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/fsv',
        component: FsvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: FsvMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: FsvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: FsvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stv',
        component: StvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: StvMonthWiseComponent,
          },
          {
            path: 'district-wise',
            component: StvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stf',
        component: StfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: StfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: StfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/rtf',
        component: RtfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: RtfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: RtfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: RtfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/mi-verification-subsidy-report',
        component: MiVerificationSubsidyReportComponent,     
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/tank-abstract-report',
        component: TankAbstractReportComponent,     
      },
      {
        path: 'report/stage1-report',
        component: Stage1ReportComponent,
        
      },
      {
        path: 'report/stage2-report',
        component: Stage2ReportComponent,
        
      },
      {
        path: 'report/stage3-report',
        component: Stage3ReportComponent,
        
      },
      {
        path: 'report/stage1-subsidy-report',
        component: Stage1SubsidyReportComponent,
        
      },
      {
        path: 'report/stage2-subsidy-report',
        component: Stage2SubsidyReportComponent,
        
      },
      {
        path: 'report/stage3-subsidy-report',
        component: Stage3SubsidyReportComponent,
        
      },
      {
        path: 'report/canal-and-tube-well-based-report',
        component: CanalAndTubeWellBasedReportComponent,
        
      },
      {
        path: 'report/chalan-reconciliation-day-report',
        component: ChallanReconciliationDayReportComponent,     
      },
      {
        path: 'report/7500-demo',
        component: SeventyFiveHundredDemoComponent,
      },
      {
        path: 'report/atal-bhujal-user',
        component: AtalUserComponent,
      },
      {
        path: 'report/pre-estimation',
        component: VendorPreEstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PreEstimateMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PreEstimateDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PreEstimateUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PreEstimateVendorWiseReportComponent,
          },
        ],
      },
      {
        path: 'report/consolidated-report-new',
        component: ConsolidatedDashboardComponent,     
      },
      {
        path: 'report/consolidated-report',
        component: ConsolidatedReportComponent,     
      },
      {
        path: 'report/mi-total-app-report',
        component: MiConsolidatedTotalAppReportComponent,
      },
      {
        path: 'report/mi-consolidated-details',
        component: MiConsolidatedDetailReportComponent,
      },
      {
        path: 'report/pond-total-app-report',
        component: PondConsolidateReportComponent,
      },
      {
        path: 'report/pond-consolidated-details',
        component: PondConsolidatedDetailReportComponent,
      },
      {
        path: 'report/consolidated-report/:actionType/:finYear',
        component: MiConsolidatedCountWiseReportComponent,
      },
      {
        path: 'report/pond-report/:actionType/:finYear',
        component: PondCountWiseReportComponent,
        
        
      },
      {
        path: 'report/timeline',
        component: ApplicationTypeReportComponent
      },
      {
        path: 'report/subsidy-wise-report',
        component: SubsidyWiseReportComponent
      },
      {
        path: 'report/print/:appId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'report/ranking',
        component: RankingRatingReportComponent,
      },

      {
        path: 'assign-role',
        component: UserMappingComponent,
      },
      {
        path: 'userlist',
        component: CompleteUserListComponent,
      },
      {
        path: 'report/user-wise-pending-report',
        component: DaWisePendingReportComponent
      },
      // {
      //   path: 'target-system',
      //   component: TargetSystemComponent
      // }  
      // {
      //   path: 'vendor-registration',
      //   component: VendorRegistrationsComponent
      // },
      // { path: 'vendor-data', 
      //   component: VendorDataComponent 
      // },
    ],
  },

  {
    path: 'xen',
    component: InnerPageLayoutComponent,
    canActivateChild: [XenGuardGuard],
    children: [
      { path: '', redirectTo: 'xen', pathMatch: 'full' },

      {
        path: 'xen',
        component: XenComponent,
      },
      
      {
        path: 'xen/xen-form',
        component: XenFormComponent,
      },

      {
        path: 'tank-stage1',
        component: TankStage1Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage1PendingComponent },
          { path: 'current', component: TankStage1CurrentComponent },
          { path: 'approved', component: TankStage1ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage2',
        component: TankStage2Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage2PendingComponent },
          { path: 'current', component: TankStage2CurrentComponent },
          { path: 'approved', component: TankStage2ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage3',
        component: TankStage3Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage3PendingComponent },
          { path: 'current', component: TankStage3CurrentComponent },
          { path: 'approved', component: TankStage3ApprovedComponent },
        ],
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'report/user-wise-pending-report',
        component: DaWisePendingReportComponent
      },
      // {
      //   path: 'xen/tank-stage3',
      //   component: TankStage3Component,
      // },
    ],
  },
  {
    path: 'helpdesk',
    component: InnerPageLayoutComponent,
    canActivateChild: [HelpdeskGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HelpdeskComponent,
      },
      // {
      //   path: 'home/:appId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'home/view',
        component: ConsentFormComponent,
      },
      {
        path: 'print',
        component: ConsentFormComponent,
      },
    ],
  },
  {
    path: 'cao',
    component: InnerPageLayoutComponent,
    canActivateChild: [CAOGuardGuard],
    children: [
      { path: '', redirectTo: 'mi-farmer-share-to-vendor/pdmc', pathMatch: 'full' },
      { path: 'mi-farmer-share-to-vendor/pdmc', component: FarmerShareToVendorPfmsReportComponent, pathMatch: 'full' },
      // { path: 'mi-farmer-share-to-farmer/aby', component: FarmerShareToFarmerPfmsReportComponent, pathMatch: 'full' },
      { path: 'mi-subsidy-to-farmer/pdmc', component: SubsidyToFarmerPfmsReportComponent, pathMatch: 'full' },
      { path: 'mi-subsidy-to-farmer/aby', component: SubsidyToFarmerAbyPfmsReportComponent, pathMatch: 'full' },
      { path: 'mi-subsidy-to-farmer-esparsh', component: SubsidyToFarmerPfmsEsparshComponent, pathMatch: 'full' },
      { path: 'mi-subsidy-to-vendor/pdmc', component: SubsidyToVendorPfmsReportComponent, pathMatch: 'full' },
      { path: 'mi-subsidy-to-vendor-esparsh', component: SubsidyToVendorPfmsEsparshComponent, pathMatch: 'full' },
      { path: 'mi-subsidy-to-vendor/aby', component: SubsidyToVendorAbyPfmsReportComponent, pathMatch: 'full' },
      { path: 'mi-refund-to-farmer/pdmc', component: ReturnToFarmerPfmsReportComponent, pathMatch: 'full' },
      // { path: 'mi-refund-to-farmer/aby', component: RefundToFarmerAbyComponent, pathMatch: 'full' },
      { path: 'import/pfms', component: ImportPfmsDataComponent, pathMatch: 'full' },
      { path: 'import/bank-transaction', component: ImportBankDataComponent, pathMatch: 'full' },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'pond/tank-stage1/pfms',
        component: TankStage1PfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage1/aby',
        component: TankStage1AbyPfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage1/esparsh',
        component: TankStage1PfmsESparshComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage2/pfms',
        component: TankStage2PfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage2/aby',
        component: TankStage2AbyPfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage2/esparsh',
        component: TankStage2PfmsESparshComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage3/pfms',
        component: TankStage3PfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage3/aby',
        component: TankStage3AbyPfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage3/esparsh',
        component: TankStage3PfmsESparshComponent,
        pathMatch: 'full'
      },
      {
        path: 'report/chalan-reconciliation-day-report',
        component: ChallanReconciliationDayReportComponent,     
      },
      {
        path: 'report/lot-wise-report',
        component: LotWiseReportComponent,
        
        children: [
          // { path: '', redirectTo: 'fsv', pathMatch: 'full' },
          { path: 'fsv', component: FsvLotReportComponent, pathMatch: 'full' },
          { path: 'stf', component: StfLotReportComponent, pathMatch: 'full' },
          { path: 'stv', component: StvLotReportComponent, pathMatch: 'full' },
          { path: 'rtf', component: RtfLotReportComponent, pathMatch: 'full' },
          { path: 'stage1', component: Stage1LotReportComponent, pathMatch: 'full' },
          { path: 'stage2', component: Stage2LotReportComponent, pathMatch: 'full' },
          { path: 'stage3', component: Stage3LotReportComponent, pathMatch: 'full' },
        ],
      },
      {
        path:'helpdesk',
        component: HelpdeskComponent,
      },
      // {
      //   path: 'helpdesk/:appId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'helpdesk/view',
        component: ConsentFormComponent,
      },
      {
        path: 'report/lot-report',
        component: LotReportComponent,     
      },
      {
        path: 'report/lot-consolidated-report',
        component: LotConsolidatedReportComponent,     
      },
      {
        path: 'report/consolidated-report',
        component: ConsolidatedReportComponent,
      },
      {
        path: 'report/consolidated-report-new',
        component: ConsolidatedDashboardComponent,
      },
      {
        path: 'report/mi-total-app-report',
        component: MiConsolidatedTotalAppReportComponent,
      },
      {
        path: 'report/mi-consolidated-details',
        component: MiConsolidatedDetailReportComponent,
      },
      {
        path: 'report/pond-total-app-report',
        component: PondConsolidateReportComponent,
      },
      {
        path: 'report/pond-consolidated-details',
        component: PondConsolidatedDetailReportComponent,
      },
      {
        path: 'report/consolidated-report/:actionType/:finYear',
        component: MiConsolidatedCountWiseReportComponent,
      },
      {
        path: 'report/pond-report/:actionType/:finYear',
        component: PondCountWiseReportComponent, 
      }, 
      {
        path: 'report/financial-details',
        component: CaoFinancialDetailsComponent, 
      },
      {
        path: 'report/subsidy-disbursed',
        component: SubsidyDistributionComponent, 
      }    
    ],
  },
  {
    path: 'dev',
    component: InnerPageLayoutComponent,
    canActivateChild: [DevGuard],
    children: [
      { path: '', redirectTo: 'request-solar', pathMatch: 'full' },
      { path: 'request-solar', component: RequestSolarComponent, pathMatch: 'full' },
      { path: 'solar-procedure', component: SolarProcedureComponent, pathMatch: 'full' },
      { path: 'solar-flow', component: AddToSolarFlowComponent, pathMatch: 'full' },
      { path: 'modify-solar', component: ModifySolarComponent, pathMatch: 'full' },
      { path: 'get-solar', component: GetSolarComponent, pathMatch: 'full' },
      { path: 'solar-list', component: SolarListComponent, pathMatch: 'full' },
      { path: 'error-tracking', component: ErrorTrackingComponent, pathMatch: 'full' },
    ]
  },
  {
    path: 'subdev',
    component: InnerPageLayoutComponent,
    canActivateChild: [SubDevGuard],
    children: [
      // { path: '', redirectTo: 'request-solar', pathMatch: 'full' },
      { path: '', redirectTo: 'error-tracking', pathMatch: 'full' },
      // { path: 'request-solar', component: RequestSolarComponent, pathMatch: 'full' },
      // { path: 'solar-flow', component: AddToSolarFlowComponent, pathMatch: 'full' },
      // { path: 'get-solar', component: GetSolarComponent, pathMatch: 'full' },
      { path: 'error-tracking', component: ErrorTrackingComponent, pathMatch: 'full' },
    ]
  },
  {
    path: 'ew-je',
    component: InnerPageLayoutComponent,
    canActivateChild: [JEGuardGuard],
    children: [
      { path: '', redirectTo: 'farmer-applications', pathMatch: 'full' },
      {
        path: 'farmer-applications',
        component: FarmerApplicationVerificationComponent,
        
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: FarmerApplicationVerificationPendingComponent,
          },
          {
            path: 'current',
            component: FarmerApplicationVerificationCurrentComponent,
          },
          {
            path: 'approved',
            component: FarmerApplicationVerificationCompletedComponent,
          },
        ],
      },
      {
        path: 'tank-stage1',
        component: TankStage1Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage1PendingComponent },
          { path: 'current', component: TankStage1CurrentComponent },
          { path: 'approved', component: TankStage1ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage2',
        component: TankStage2Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage2PendingComponent },
          { path: 'current', component: TankStage2CurrentComponent },
          { path: 'approved', component: TankStage2ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage3',
        component: TankStage3Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage3PendingComponent },
          { path: 'current', component: TankStage3CurrentComponent },
          { path: 'approved', component: TankStage3ApprovedComponent },
        ],
      },
      {
        path: 'report/stage1-report',
        component: Stage1ReportComponent,
        
      },
      {
        path: 'report/stage2-report',
        component: Stage2ReportComponent,
        
      },
      {
        path: 'report/stage3-report',
        component: Stage3ReportComponent,
        
      },
      {
        path: 'report/stage1-subsidy-report',
        component: Stage1SubsidyReportComponent,
        
      },
      {
        path: 'report/stage2-subsidy-report',
        component: Stage2SubsidyReportComponent,
        
      },
      {
        path: 'report/stage3-subsidy-report',
        component: Stage3SubsidyReportComponent,
        
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'appliaction-approval/print/:appId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'appliaction-approval/print',
        component: DepartmentConsentFormComponent,
      },
      {
        path:'helpdesk',
        component: HelpdeskComponent,
      },
      // {
      //   path: 'helpdesk/:appId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'helpdesk/view',
        component: ConsentFormComponent,
      },
    ]
  },
  {
    path: 'ew-department',
    component: InnerPageLayoutComponent,
    canActivateChild: [DepartmentGuardGuard],
    children: [
      { path: '', redirectTo: 'farmer-applications', pathMatch: 'full' },
      {
        path: 'farmer-applications',
        component: FarmerApplicationVerificationComponent,
        
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: FarmerApplicationVerificationPendingComponent,
          },
          {
            path: 'current',
            component: FarmerApplicationVerificationCurrentComponent,
          },
          {
            path: 'approved',
            component: FarmerApplicationVerificationCompletedComponent,
          },
        ],
      },
      {
        path: 'tank-stage1',
        component: TankStage1Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage1PendingComponent },
          { path: 'current', component: TankStage1CurrentComponent },
          { path: 'approved', component: TankStage1ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage2',
        component: TankStage2Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage2PendingComponent },
          { path: 'current', component: TankStage2CurrentComponent },
          { path: 'approved', component: TankStage2ApprovedComponent },
        ],
      },
      {
        path: 'tank-stage3',
        component: TankStage3Component,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: TankStage3PendingComponent },
          { path: 'current', component: TankStage3CurrentComponent },
          { path: 'approved', component: TankStage3ApprovedComponent },
        ],
      },
      {
        path:'pond/tankstage-1',
        component: Tankstagesurvey1Component,
      },
      {
        path:'pond/tankstage-2',
        component: Tankstagesurvey2Component,
      },
      {
        path:'pond/tankstage-3',
        component: Tankstagesurvey3Component,
      },
      {
        path: 'all-subsidy-lot',
        component: AllSubsidyLotComponent,
        
        children: [
          
          // { path: 'mi-farmer-share-to-vendor/pfms', component: FarmerShareToVendorPfmsReportComponent,  },
          // { path: 'mi-subsidy-to-farmer/pfms', component: SubsidyToFarmerPfmsReportComponent,  },
          // { path: 'mi-subsidy-to-vendor/pfms', component: SubsidyToVendorPfmsReportComponent, },
          // { path: 'mi-refund-to-farmer/pfms', component: ReturnToFarmerPfmsReportComponent,  },
          { path: 'import/pfms', component: ImportPfmsDataComponent,  },
          
          { path: 'pond/tank-stage1/pdmc', component: TankStage1PfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage1/aby', component: TankStage1AbyPfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage2/pdmc', component: TankStage2PfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage2/aby', component: TankStage2AbyPfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage3/pdmc', component: TankStage3PfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage3/aby', component: TankStage3AbyPfmsReportComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage1/esparsh', component: TankStage1PfmsESparshComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage2/esparsh', component: TankStage2PfmsESparshComponent, pathMatch: 'full' },
          { path: 'pond/tank-stage3/esparsh', component: TankStage3PfmsESparshComponent, pathMatch: 'full'},
        ],
      },
      {
        path: 'failed-pond-payment',
        component: FailedPondPaymentComponent,
        
        children: [
          // { path: '', redirectTo: 'mi-farmer-share-to-vendor/pdmc', pathMatch: 'full' },
          { path: 'stage1', component: FailedPondPaymentS1Component, pathMatch: 'full' },
          { path: 'stage2', component: FailedPondPaymentS2Component, pathMatch: 'full' },
          { path: 'stage3', component: FailedPondPaymentS3Component, pathMatch: 'full' },
        ],
      },
      {
        path: 'report/timeline',
        component: ApplicationTypeReportComponent
      },
      {
        path: 'report/consolidated-report',
        component: ConsolidatedReportComponent,
      },
      {
        path: 'report/consolidated-report-new',
        component: ConsolidatedDashboardComponent,     
      },
      {
        path: 'report/mi-total-app-report',
        component: MiConsolidatedTotalAppReportComponent,
      },
      {
        path: 'report/mi-consolidated-details',
        component: MiConsolidatedDetailReportComponent,
      },
      {
        path: 'report/pond-total-app-report',
        component: PondConsolidateReportComponent,
      },
      {
        path: 'report/pond-consolidated-details',
        component: PondConsolidatedDetailReportComponent,
      },
      {
        path: 'report/app-verification',
        component: AppVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: MonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: DistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: UserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: VendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/boq',
        component: BOQReportComponent,
        
        children: [
          { path: '', redirectTo: 'boq-month-wise', pathMatch: 'full' },
          {
            path: 'boq-month-wise',
            component: BoqMonthWiseReportComponent,
          },
          {
            path: 'boq-district-wise',
            component: BoqDistrictWiseReportComponent,
          },
          {
            path: 'boq-mi-type',
            component: BoqMiTypeReportComponent,
          },
          {
            path: 'boq-vendor-wise',
            component: BoqVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation-verification',
        component: EstimationVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: EstVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: EstVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: EstVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: EstVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/challan',
        component: ChallanReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: ChallanDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: ChallanVendorWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: ChallanMonthWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/physical-verification',
        component: PhysicalVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PhysicalVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PhysicalVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PhysicalVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PhysicalVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/fsv',
        component: FsvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: FsvMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: FsvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: FsvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stv',
        component: StvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: StvMonthWiseComponent,
          },
          {
            path: 'district-wise',
            component: StvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stf',
        component: StfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: StfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: StfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/rtf',
        component: RtfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: RtfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: RtfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: RtfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/mi-verification-subsidy-report',
        component: MiVerificationSubsidyReportComponent,     
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/tank-abstract-report',
        component: TankAbstractReportComponent,     
      },
      {
        path: 'report/stage1-report',
        component: Stage1ReportComponent,
        
      },
      {
        path: 'report/stage2-report',
        component: Stage2ReportComponent,
        
      },
      {
        path: 'report/stage3-report',
        component: Stage3ReportComponent,
        
      },
      {
        path: 'report/stage1-subsidy-report',
        component: Stage1SubsidyReportComponent,
        
      },
      {
        path: 'report/stage2-subsidy-report',
        component: Stage2SubsidyReportComponent,
        
      },
      {
        path: 'report/stage3-subsidy-report',
        component: Stage3SubsidyReportComponent,
        
      },
      {
        path: 'report/canal-and-tube-well-based-report',
        component: CanalAndTubeWellBasedReportComponent,
        
      },
      {
        path: 'report/chalan-reconciliation-day-report',
        component: ChallanReconciliationDayReportComponent,     
      },
      {
        path: 'report/7500-demo',
        component: SeventyFiveHundredDemoComponent,
      },
      {
        path: 'report/atal-bhujal-user',
        component: AtalUserComponent,
      },
      {
        path: 'report/pre-estimation',
        component: VendorPreEstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PreEstimateMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PreEstimateDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PreEstimateUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PreEstimateVendorWiseReportComponent,
          },
        ],
      },
      {
        path: 'report/da-report',
        component: DaReportComponent,
        children: [
          {
            path: 'mi',
            component: MiDaReportComponent,
          },
          {
            path: 'pond',
            component: PondDaReportComponent,
          },
         
        ],
      },
      {
        path: 'report/inventory-report',
        component: InventoryReportComponent,
      },
      {
        path: 'report/consolidated-report',
        component: ConsolidatedReportComponent,
      },
      {
        path: 'report/mi-total-app-report',
        component: MiConsolidatedTotalAppReportComponent,
      },
      {
        path: 'report/mi-consolidated-details',
        component: MiConsolidatedDetailReportComponent,
      },
      {
        path: 'report/pond-total-app-report',
        component: PondConsolidateReportComponent,
      },
      {
        path: 'report/pond-consolidated-details',
        component: PondConsolidatedDetailReportComponent,
      },
      {
        path: 'report/consolidated-report/:actionType/:finYear',
        component: MiConsolidatedCountWiseReportComponent,
      },
      {
        path: 'report/pond-report/:actionType/:finyear',
        component: PondCountWiseReportComponent, 
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'appliaction-approval/print/:appId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'appliaction-approval/print',
        component: DepartmentConsentFormComponent,
      },
      {
        path:'helpdesk',
        component: HelpdeskComponent,
      },
      // {
      //   path: 'helpdesk/:appId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'helpdesk/view',
        component: ConsentFormComponent,
      },
      {
        path: 'report/user-wise-pending-report',
        component: DaWisePendingReportComponent
      },
    ]
  },
  {
    path: 'user-action',
    component: InnerPageLayoutComponent,
    canActivateChild: [UserActionGuard],
    children: [
      { path: '', redirectTo: 'canal', pathMatch: 'full' },
      { path: 'canal', component: CanalTargetComponent, pathMatch: 'full' },
      { path: 'stp', component: StpTargetComponent, pathMatch: 'full' },
      { path: 'overflow-pond', component: OverFlowPondComponent, pathMatch: 'full' },
      { path: 'crop-master', component: CropMasterStatusComponent, pathMatch: 'full' },
    ]
  },
  {
    path: 'contractor',
    component: InnerPageLayoutComponent,
    canActivateChild: [ContractorGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard',  component: ContractorDashboardComponent,  pathMatch: 'full' },
      { path: 'new-work', component: NewWorkComponent, pathMatch: 'full' },
      { path: 'update-work', component: UpdateWorkComponent, pathMatch: 'full' },
      { path: 'report/estimation-details', component: EpcEstimationDetailsComponent, pathMatch: 'full' },
    ]
  },
  {
    path: 'ptg-dev-team',
    component: InnerPageLayoutComponent,
    canActivateChild: [DevTeamGuard],
    children: [
      { path: '', redirectTo: 'unhide-application', pathMatch: 'full' },
      {
        path: 'unhide-application',
        component: UnhideApplicationComponent
      },
      {
        path: 'change-details',
        component: ChangeVendorComponent
      },
    ]
  },
  {
    path: 'grievance-handler',
    component: InnerPageLayoutComponent,
    canActivateChild: [GrievanceHandlerGuard],
    children: [
      { path: '', redirectTo: 'grievance-handler', pathMatch: 'full' },
      {
        path: 'grievance-handler',
        component: GrievanceHandlerComponent
      },
    ]
  },
  {
    path: 'webadmin',
    component: InnerPageLayoutComponent,
    canActivateChild: [WebadminGuard],
    children: [
      { path: '', redirectTo: 'report/consolidated-report-new', pathMatch: 'full' },
      {
        path: 'report/consolidated-report-new',
        component: ConsolidatedDashboardComponent,     
      },
      {
        path: 'report/consolidated-report',
        component: ConsolidatedReportComponent,     
      },
      {
        path: 'report/mi-total-app-report',
        component: MiConsolidatedTotalAppReportComponent,
      },
      {
        path: 'report/mi-consolidated-details',
        component: MiConsolidatedDetailReportComponent,
      },
      {
        path: 'report/pond-total-app-report',
        component: PondConsolidateReportComponent,
      },
      {
        path: 'report/pond-consolidated-details',
        component: PondConsolidatedDetailReportComponent,
      },
      {
        path: 'report/consolidated-report/:actionType/:finYear',
        component: MiConsolidatedCountWiseReportComponent,
      },
      {
        path: 'report/pond-report/:actionType/:finYear',
        component: PondCountWiseReportComponent,
      },
      {
        path: 'unhide-application',
        component: UnhideApplicationComponent
      },
      {
        path: 'change-details',
        component: ChangeVendorComponent
      },
      {
        path: 'report/financial-details',
        component: CaoFinancialDetailsComponent, 
      },
      {
        path: 'report/subsidy-disbursed',
        component: SubsidyDistributionComponent, 
      },
      {
        path:'helpdesk',
        component: HelpdeskComponent,
      },
      // {
      //   path: 'helpdesk/:appId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'helpdesk/view',
        component: ConsentFormComponent,
      },
      {
        path: 'print',
        component: ConsentFormComponent,
      },
      {
        path: 'update-jamabandi',
        component: UpdateJamabandiComponent,
      },
      { 
        path: 'mi-pond-target', 
        component: MiPondTargetComponent 
      },
      {
        path: 'report/user-wise-pending-report',
        component: DaWisePendingReportComponent
      },
    ]
  },
  
  
  // {
  //   path: 'geo-location',
  //   component: GeolocationComponent
  // },
  {
    path: "", redirectTo: "/home", pathMatch: "full"
  },
  {
    path: "**", redirectTo: "/home", pathMatch: "full"
  }
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
